module.exports = __webpack_public_path__ + "img/duoduo.80847199.png";